import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import history from "./history";
import * as serviceWorker from "./serviceWorker";
import { Router } from "react-router-dom";
import "./i18n";
import { config } from "./Config/config";
import ReactGA from "react-ga";
ReactGA.initialize(config.googleAnalytics, {
  titleCase: false
});

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
